export const IS_DEBUG = false;
export const BREAK_WIDTH_PC = 860;
export const WIDTH_SP = 375;
export const WIDTH_PC = 1200;

export const CROSSWORD_ID_NORMAL = "normal";
export const CROSSWORD_ID_HARD = "hard";

export const MICRO_MODAL_CONFIG = {
  awaitCloseAnimation: true,
  disableScroll: true,
  disableFocus: true,
};